import apiStore from '@/api/stores'

const state = {
  isLoading: false,
  sportsObjects: [],
  validationErrors: null,
  isSubmitting: false,
}

export const mutationTypes = {
  addStoreStart: '[create store] create store Start',
  addStoreSuccess: '[create store] create store Success',
  addStoreFailure: '[create store] create store Failure',
}

export const actionType = {
  addStore: '[sportsObjects] addStore',
}

const mutations = {
  [mutationTypes.addStoreStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addStoreSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addStoreFailure](state) {
    state.isSubmitting = false
  },
}

const actions = {
  [actionType.addStore](context, sport) {
    context.commit(mutationTypes.addStoreStart)
    return new Promise((resolve) => {
      apiStore
        .addStores(sport)
        .then((response) => {
          context.commit(mutationTypes.addStoreSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.addStoreFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
